/**
 * @generated SignedSource<<19ed88a0cc06965b0e37943fe5c22b10>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ArchiveFlowInput = {
  clientMutationId?: string | null | undefined;
  flowId: UUID;
};
export type TemplateOptionsMutation$variables = {
  input: ArchiveFlowInput;
};
export type TemplateOptionsMutation$data = {
  readonly archiveFlow: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type TemplateOptionsMutation = {
  response: TemplateOptionsMutation$data;
  variables: TemplateOptionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveFlowPayload",
    "kind": "LinkedField",
    "name": "archiveFlow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TemplateOptionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemplateOptionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d13a6a4bf485c7678a4159ccbaf406e6",
    "id": null,
    "metadata": {},
    "name": "TemplateOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation TemplateOptionsMutation(\n  $input: ArchiveFlowInput!\n) {\n  archiveFlow(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3e2a5a210ebda46b154c1741ab0fbd9a";

export default node;
